import React, { Component } from 'react';
import { Form, Input, Button, Card, Image, Row, notification } from 'antd';
import './Login.css';
import { login_profile, load_profile } from '../redux/actions/profile';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import w_logo from '../assets/warithep_logo.jpeg';

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loginFailed: false
        }
        this.onFinish = this.onFinish.bind(this)
        this.onFinishFailed = this.onFinishFailed.bind(this)
    }

    async onFinish(values) {
        const { history, dispatch } = this.props;
        
        try {
            const role = await dispatch(login_profile(values.username, values.password))
            if (role === "ADMIN"){
                history.push('/users')
            }
            else if (role === "BRANCH_MANAGER") {
                history.push('/routes')
            }
            // else if (role === "SALESMAN") {
            //     history.push('/route_detail')
            // }
            else if (role === null){
                this.setState({loginFailed: true})
            }
        }
        catch (err) {
            console.log(err.response)
            notification["error"]({
                message: `ไม่สามารถลงชื่อเข้าใช้ (${err.response.status})`,
                description: err.response.data.error
            });
        }

        
    };

    onFinishFailed(errorInfo) {
        console.log('Failed:', errorInfo);
    };

    render() {
        const { loginFailed } = this.state
        return (
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: "#f0f2f5"}}>
                <Row style={{marginBottom: 10}}>
                    <Image
                        width={200}
                        src={w_logo}
                        preview={false}
                    />
                </Row>
                <Row>
                    <Card style={{ width: 400 }}>
                        {loginFailed && <div style={{width: '100%', color: 'red', textAlign: 'center', marginBottom: 10}}>ชื่อผู้ใช้ หรือรหัสผ่านไม่ถูกต้อง</div>}
                        <Form
                            name="basic"
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Form.Item
                                label="ชื่อผู้ใช้"
                                name="username"
                                rules={[{ required: true, message: 'กรุณาใส่ชื่อผู้ใช้' }]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="รหัสผ่าน"
                                name="password"
                                rules={[{ required: true, message: 'กรุณาใส่รหัสผ่าน' }]}
                            >
                                <Input.Password />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    ลงชื่อเข้าใช้
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default withRouter(connect(mapStateToProps)(Login));